import Vue from 'vue';
import { ActionTree } from 'vuex';
import { LOGIN, LOGOUT } from '@/store/auth/mutation-types';
import { AuthState } from '@/types/store/AuthState';
import { RootState } from '@/types/store/RootState';

const actions: ActionTree<AuthState, RootState> = {
  async login({ dispatch }, payload): Promise<Error|Promise<void>> {
    try {
      const response = await Vue.prototype.$api.post('/api/login', {
        email: payload.email,
        password: payload.password,
      });

      if (response) {
        if (response.status !== 200) {
          // If status is not 200, create Promise and reject immediately.
          return new Promise<Error>((resolve, reject) => {
            reject(new Error('Request failed'));
          });
        }
        if (!response?.data?.token || !response?.data?.user) {
          // If needed date is not in response, create Promise and reject immediately.
          return new Promise<Error>(((resolve, reject) => {
            reject(new Error('Wrong data'));
          }));
        }

        // If we're in browser, store data in LocalStorage.
        if (window?.localStorage) {
          window.localStorage.setItem('user', JSON.stringify(response.data));
        }

        return dispatch('getUser', response.data);
      }

      return new Promise<Error>(((resolve, reject) => {
        reject(new Error('Server sent no response'));
      }));
    } catch (e) {
      return new Promise<Error>(((resolve, reject) => {
        reject(e);
      }));
    }
  },

  async getUser({ commit }, payload): Promise<void|Promise<Error>> {
    Vue.prototype.$api.defaults.headers.common.Authorization = `Bearer ${payload.token}`;

    const { data: user } = await Vue.prototype.$api.get(payload.user);

    // Only log in if user is Admin
    if (user?.roles.indexOf('ROLE_SUPER_ADMIN') > -1 || user?.roles.indexOf('ROLE_ADMIN') > -1) {
      return commit(LOGIN, user);
    }

    return new Promise<Error>(((resolve, reject) => {
      reject(new Error('Access denied'));
    }));
  },

  async logout({ commit }): Promise<void> {
    Vue.prototype.$api.defaults.headers.common.Authorization = undefined;

    commit(LOGOUT);
  },
};

export default actions;
